"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskControls = exports.TaskContent = exports.TaskContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectMixins = require("@wealthmigrate/architect-mixins");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // SHARED-PLATFORM [ TASK > STYLE ] ############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. MAIN CONTAINER .........................................................


var TaskContainer = _styledComponents["default"].aside.withConfig({
  displayName: "indexstyle__TaskContainer",
  componentId: "sc-39i4qp-0"
})(["position:fixed;right:0;top:0;bottom:0;display:flex;flex-direction:column;justify-content:flex-start;width:40%;box-shadow:var(--shadow);background-color:var(--color-white);&:after{background:inherit;position:absolute;bottom:0;top:0;left:-80px;content:'';display:block;width:80px;clip-path:var(--angle-vertical-bottom);z-index:-1;}@media ", "{width:auto;top:var(--gutter-small);right:var(--gutter-small);bottom:var(--gutter-small);left:var(--gutter-small);border-radius:var(--radius-small);&:after{display:none;}}@media ", "{width:60%;}"], _architectMixins._mixin_device.s, _architectMixins._mixin_device.m); // 3.1. END ....................................................................
// 3.2. CONTROLS ...............................................................


exports.TaskContainer = TaskContainer;

var TaskContent = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__TaskContent",
  componentId: "sc-39i4qp-1"
})(["display:flex;flex-direction:column;justify-content:space-between;padding:0 var(--gutter);margin-bottom:var(--gutter-medium);margin-top:", ";overflow-y:scroll;header{flex:none;border-bottom:solid 2px var(--color-lighter);margin-bottom:var(--gutter);padding-bottom:var(--gutter);h3{font-family:var(--family-secondary);font-weight:var(--weight-bold);margin-bottom:var(--gutter-small);}}section{flex:1;}footer{flex:none;border-top:solid 2px var(--color-lighter);margin-top:var(--gutter);padding-top:var(--gutter);}"], function (_ref) {
  var hasControls = _ref.hasControls;
  return !hasControls ? 'var(--gutter-medium)' : '0';
}); // 3.2. END ....................................................................
// 3.2. CONTROLS ...............................................................


exports.TaskContent = TaskContent;

var TaskControls = _styledComponents["default"].nav.withConfig({
  displayName: "indexstyle__TaskControls",
  componentId: "sc-39i4qp-2"
})(["flex:none;display:flex;justify-content:flex-end;margin:var(--gutter);ul{", "}"], (0, _architectMixins._mixin_make_list)()); // 3.2. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.TaskControls = TaskControls;